import React, { useState } from "react";
import axios from "axios";
import { Loading } from "notiflix";
import { Notify } from "notiflix";
import "./form1.css";
import { useNavigate } from "react-router-dom";

const Formta1 = ({ formData, setFormData, step, setStep }) => {
  console.log("formdata", formData);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
 
    if (!formData.registeredBy) newErrors.registeredBy = "தேர்ந்தெடுக்கவும்";
    if (!formData.name) newErrors.name = "தேர்ந்தெடுக்கவும்";
    if (!formData.gender) newErrors.gender = "தேர்ந்தெடுக்கவும்";
    if (!formData.dobDay) newErrors.dobDay = "தேர்ந்தெடுக்கவும்";
    if (!formData.dobMonth) newErrors.dobMonth = "தேர்ந்தெடுக்கவும்";
    if (!formData.dobYear) newErrors.dobYear = "தேர்ந்தெடுக்கவும்";
    if (!formData.birthHour) newErrors.birthHour = "தேர்ந்தெடுக்கவும்";
    if (!formData.birthMinute) newErrors.birthMinute = "தேர்ந்தெடுக்கவும்";
    if (!formData.birthAmPm) newErrors.birthAmPm = "தேர்ந்தெடுக்கவும்";
    if (!formData.birthPlace) newErrors.birthPlace = "தேர்ந்தெடுக்கவும்";
    if (!formData.maritalStatus) newErrors.maritalStatus = "தேர்ந்தெடுக்கவும்";

    if (!formData.mobile) {
      newErrors.mobile = "தேர்ந்தெடுக்கவும்";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "செல்லுபடியாகும் 10 இலக்க எண்ணை உள்ளிடவும்.";
    }

    if (!formData.alternateMobile) {
      newErrors.alternateMobile = "தேர்ந்தெடுக்கவும்";
    } else if (!/^\d{10}$/.test(formData.alternateMobile)) {
      newErrors.alternateMobile = "செல்லுபடியாகும் 10 இலக்க எண்ணை உள்ளிடவும்.";
    }

    return newErrors;
  };

  const HandleNext = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      Loading.standard('Loading...');

      axios.post('https://kovaikongunadumatrimony.com/kkm_backend/public/api/check-exisiting-user', {
        mobile_number: formData.mobile
      }).then(response => {

        if (response.data.status == true) {
          setStep(2);
          Loading.remove();

        } else {
          Notify.failure(response.data.message);
          Loading.remove();
        }
      });
    }
  };

  return (
    <>
      <div className="form-background">
        <div className="form-section">
          <h2 className="form-title">
            Create Your Account
            <h5 className="text-success"><b>Kongu Vellalar community only</b></h5>
            (பிறப்பு விவரங்கள்(1/7))
          </h2>
          <form>
            <div className="form-row">
              <div className="form-group half-width">
                <label>
                  <b>
                    பதிவுசெய்தவர்<span className="error fs-star">*</span>
                  </b>
                </label>
                <select
                  name="registeredBy"
                  value={formData.registeredBy}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="Father">தந்தை</option>
                  <option value="Mother">தாய்</option>
                  <option value="Friend">நண்பர்</option>
                  <option value="Other">மற்றவை</option>
                </select>
                {errors.registeredBy && (
                  <p className="error">{errors.registeredBy}</p>
                )}
              </div>

              <div className="form-group half-width">
                <label>
                  <b>
                    முழு பெயர்<span className="error fs-star">*</span>
                  </b>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="முழு பெயரை உள்ளிடவும்"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="error">{errors.name}</p>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group half-width">
                <label>
                  <b>
                    பாலினம்<span className="error fs-star">*</span>
                  </b>
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="Male">ஆண்</option>
                  <option value="Female">பெண்</option>
                </select>
                {errors.gender && <p className="error">{errors.gender}</p>}
              </div>

              <div className="form-group half-width">
                <label>
                  <b>
                    திருமண நிலை<span className="error fs-star">*</span>
                  </b>
                </label>
                <select
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="Unmarried">திருமணமாகாதவர்</option>
                  <option value="married">திருமணமானவர்</option>
                  <option value="divorced">விவாகரத்து</option>
                  <option value="widowed">விதவை</option>
                </select>
                {errors.maritalStatus && (
                  <p className="error">{errors.maritalStatus}</p>
                )}
              </div>
            </div>

            <div className="form-group full-width">
              <label>
                <b>
                  பிறந்த தேதி<span className="error fs-star">*</span>
                </b>
              </label>
              <div className="dob-selects">
                <div>
                  <select
                    name="dobDay"
                    value={formData.dobDay}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">நாள்</option>
                    {Array.from({ length: 31 }, (_, i) => {
                      const day = String(i + 1).padStart(2, "0");
                      return (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      );
                    })}
                  </select>

                  {errors.dobDay && <p className="error">{errors.dobDay}</p>}
                </div>
                <div>
                  <select
                    name="dobMonth"
                    value={formData.dobMonth}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">மாதம்</option>
                    {Array.from({ length: 12 }, (_, i) => {
                      const month = String(i + 1).padStart(2, "0");
                      return (
                        <option key={month} value={month}>
                          {month}
                        </option>
                      );
                    })}
                  </select>

                  {errors.dobMonth && (
                    <p className="error">{errors.dobMonth}</p>
                  )}
                </div>
                <div>
                  <select
                    name="dobYear"
                    value={formData.dobYear}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">வருடம்</option>
                    {Array.from({ length: new Date().getFullYear() - 1951 + 1 }, (_, i) => {
                      const year = 1951 + i;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>

                  {errors.dobYear && <p className="error">{errors.dobYear}</p>}
                </div>
              </div>
            </div>

            <div className="form-group full-width mt-4">
              <label>
                <b>
                  பிறந்த நேரம்<span className="error fs-5">*</span>
                </b>
              </label>
              <div className="time-selects">
                <div>
                  <select
                    name="birthHour"
                    value={formData.birthHour}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">மணி</option>
                    {Array.from({ length: 13 }, (_, i) => {
                      const hour = String(i).padStart(2, "0");
                      return (
                        <option key={hour} value={hour}>
                          {hour}
                        </option>
                      );
                    })}
                  </select>
                 
                  {errors.birthHour && (
                    <p className="error">{errors.birthHour}</p>
                  )}
                </div>
                <div>
                  <select
                    name="birthMinute"
                    value={formData.birthMinute}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">நிமிடம்</option>
                    {Array.from({ length: 59 }, (_, i) => {
                      const minute = String(i).padStart(2, "0");
                      return (
                        <option key={minute} value={minute}>
                          {minute}
                        </option>
                      );
                    })}
                  </select>
                  {errors.birthMinute && (
                    <p className="error">{errors.birthMinute}</p>
                  )}
                </div>
                <div>
                  <select
                    name="birthAmPm"
                    value={formData.birthAmPm}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">AM/PM</option>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                  {errors.birthAmPm && (
                    <p className="error">{errors.birthAmPm}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="form-row mt-4">
              <div className="form-group half-width">
                <label>
                  <b>
                    பிறந்த இடம்<span className="error fs-star">*</span>
                  </b>
                </label>
                <input
                  type="text"
                  name="birthPlace"
                  placeholder="பிறந்த இடத்தை உள்ளிடவும்"
                  value={formData.birthPlace}
                  onChange={handleChange}
                />
                {errors.birthPlace && (
                  <p className="error">{errors.birthPlace}</p>
                )}
              </div>
              <div className="form-group half-width">
                <label>
                  <b>
                    தொலைபேசி எண்<span className="error fs-star">*</span>
                  </b>
                </label>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="தொலைபேசி எண்ணை உள்ளிடவும்"
                  maxLength={10}
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && <p className="error">{errors.mobile}</p>}
              </div>
            </div>

            <div className="form-group">
              <label>
                <b>
                  மாற்று தொலைபேசி எண்<span className="error fs-star">*</span>
                </b>
              </label>
              <input
                type="tel"
                name="alternateMobile"
                placeholder="மாற்று தொலைபேசி எண்ணை உள்ளிடவும்"
                maxLength={10}
                value={formData.alternateMobile}
                onChange={handleChange}
                pattern="\d*"
              />
              {errors.alternateMobile && (
                <p className="error">{errors.alternateMobile}</p>
              )}
            </div>

            <button
              type="button"
              onClick={HandleNext}
              className="submit-btn-1 mt-4"
            >
              தொடர்க
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Formta1;
